import React, { HTMLProps } from 'react'

export const visuallyHiddenStyle: React.CSSProperties = {
  border: '0px',
  clip: 'rect(0px, 0px, 0px, 0px)',
  height: '1px',
  width: '1px',
  margin: '-1px',
  padding: '0px',
  overflow: 'hidden',
  whiteSpace: 'nowrap',
  position: 'absolute',
}

/**
 * Visually hidden component used to hide
 * elements on screen
 */
export const VisuallyHidden = (props: HTMLProps<HTMLSpanElement>) => {
  return <span style={visuallyHiddenStyle} {...props} />
}
